import React, { useState } from 'react';
import { Card, Modal, Row, Col, Container } from 'react-bootstrap';

// Las importaciones de imágenes también deben ir al inicio
import foto_2 from './20260130.jpg';
import foto_1 from './20250126.jpg';

// Definimos la interfaz para los comunicados
interface Comunicado {
    id: number;
    src: string;
    title: string;
    description: string;
    fecha: string;
}

// Datos de los comunicados
const comunicados: Comunicado[] = [
    {
        id: 998,
        src: foto_2,
        title: 'Elección de delegados',
        description: 'Convocatoria especial elección de delegados.',
        fecha: '30 Enero 2026'
    },
    {
        id: 999,
        src: foto_1,
        title: 'Concocatoria asamblea',
        description: 'Convocatoria asamblea general ordinaria.',
        fecha: '23 enero 2026'
    }
];

export default function GaleriaComunicados() {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selectedComunicado, setSelectedComunicado] = useState<Comunicado | null>(null);

    const handleShowModal = (comunicado: Comunicado): void => {
        setSelectedComunicado(comunicado);
        setShowModal(true);
    };

    const handleCloseModal = (): void => {
        setShowModal(false);
        setSelectedComunicado(null);
    };

    return (
        <Container className="py-4">
            <h3 className="mb-4 text-center">Galería de Comunicados Oficiales</h3>
            
            <Row xs={1} md={2} lg={3} className="g-4">
                {comunicados.map((comunicado: Comunicado) => (
                    <Col key={comunicado.id}>
                        <Card 
                            className="h-100 shadow-sm hover-card" 
                            onClick={() => handleShowModal(comunicado)}
                            style={{ cursor: 'pointer' }}
                        >
                            <div style={{ height: '250px', overflow: 'hidden' }}>
                                <Card.Img 
                                    variant="top" 
                                    src={comunicado.src} 
                                    alt={comunicado.title}
                                    style={{ 
                                        width: '100%', 
                                        height: '100%', 
                                        objectFit: 'cover' as const
                                    }}
                                />
                            </div>
                            <Card.Body>
                                <Card.Title>{comunicado.title}</Card.Title>
                                <Card.Text>
                                    <small className="text-muted">{comunicado.fecha}</small>
                                </Card.Text>
                                <Card.Text className="text-truncate">
                                    {comunicado.description}
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>

            <Modal 
                show={showModal} 
                onHide={handleCloseModal}
                fullscreen={true}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedComunicado?.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center p-0 d-flex align-items-center justify-content-center">
                    {selectedComunicado && (
                        <img 
                            src={selectedComunicado.src} 
                            alt={selectedComunicado.title}
                            style={{ 
                                maxWidth: '100%', 
                                maxHeight: '90vh',
                                objectFit: 'contain' as const,
                                boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                            }}
                        />
                    )}
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <div>
                        <strong>Fecha:</strong> {selectedComunicado?.fecha}
                    </div>
                    <div className="text-muted">
                        {selectedComunicado?.description}
                    </div>
                </Modal.Footer>
            </Modal>

            <style>{`
                .hover-card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0,0,0,0.2) !important;
                }
            `}</style>
        </Container>
    );
}